import React from 'react';
import { XCircleIcon } from 'lucide-react';
const problems = ['Passi ore ogni settimana a pianificare le lezioni di Pilates da zero.', 'Finisci le idee e ripeti sempre gli stessi esercizi sul Mat o sul Reformer.', 'Non sai come gestire gruppi con livelli misti nello stesso momento.', 'Ti senti insicura di fronte a lesioni o allieve in gravidanza.', 'Arrivi in studio senza un piano d’azione e finisci per improvvisare.'];
export function ProblemSection() {
  return <section className="bg-[#1d0f19] px-5 py-20" data-id="element-217" data-mp="39jqoi9h8i7gt">
      <div className="mx-auto max-w-4xl text-center" data-id="element-218" data-mp="35f96aeqiw285">
        <p className="text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-219" data-mp="3jg1zmw538r9o">
          La realtà dell'insegnamento
        </p>
        <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-220" data-mp="3egpbm82hde5i">
          Insegni Pilates? Questi problemi ti suonano familiari?
        </h2>
        <div className="mt-10 grid gap-3 text-left sm:grid-cols-2" data-id="element-221" data-mp="1k3hda6faqkf4">
          {problems.map(problem => <div key={problem} className="flex gap-3 rounded-2xl border border-white/10 bg-[#2b1726] p-5" data-id="element-222" data-mp="jdn6o81bl671">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-rose-400" data-id="element-223" data-mp="obex0xmbgk94" />
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-224" data-mp="se1tjbtxmtcn">
                {problem}
              </p>
            </div>)}
        </div>
        <p className="mt-10 font-display text-3xl font-bold uppercase leading-none text-emerald-300 sm:text-4xl" data-id="element-225" data-mp="x6314kg5nvwc">
          Per quanto ancora vuoi continuare a improvvisare il tuo Pilates?
        </p>
      </div>
    </section>;
}